// -----------------------------------------------------------------------------
// Video
// -----------------------------------------------------------------------------

import * as videoUtility from '../utility/videoUtility';

const init = () => {
  if ($('.js-body').hasClass('js-body-success-story-video-list') === false) {
    return;
  }

  initVideo();
  initHeight();
};

const initVideo = () => {
  $('.js-lazy-load-video').each(function () {
    // iFrame mit YouTube-Video laden
    const div = videoUtility.initVideo(this.dataset.id);
    $(this).append(div);
  });
};

const initHeight = () => {
  const $container = $('.js-app-success-story-video-list');

  // Maximale Höhe ermitteln
  let maxHeight = 0;

  $container.find('.js-header').each(function () {
    const height = $(this).height();

    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Neue Höhe setzen
  $container.find('.js-header').each(function () {
    $(this).height(maxHeight);
  });
};

export {
  init
};
